import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb, App, Card, Row, Col, Typography, Spin, Button } from 'antd'
import IntlMessages from '../../util/IntlMessages'
import { FrontendUrls } from '../../types/urls'
import { getAuthTokens } from '@vacationtracker/shared/services/auth'
import axios from 'axios'
import { IADPUsersResponse } from '@vacationtracker/shared/types/adp'
import { useAppSelector } from '../../store/hooks'
import { selectAuthCompanySlice } from '../../store/auth-company-slice'
import logger from '@vacationtracker/shared/functions/logger'
import { v4 as uuidv4 } from 'uuid'
import { useIntl } from 'react-intl'
import { PlatformEnum } from '@vacationtracker/shared/data/platforms'
import { ADPMarketplaceBtn } from './marketplace-btn'

const { Title, Paragraph, Text } = Typography

const AdpAddonView = () => {

  const { notification } = App.useApp()
  const { formatMessage } = useIntl()
  const [data, setData] = useState<IADPUsersResponse | null>(null)
  const { authCompany } = useAppSelector(selectAuthCompanySlice)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getAdpUsersInfo()
  }, [])

  const getAdpUsersInfo = async () => {
    try {
      const tokens = await getAuthTokens()
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/integrations/adp/users-stats`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokens?.idToken}`,
        },
        params: {
          platformToken: localStorage.getItem('vt-onboarding-platform-token'),
        },
      }) as {data: IADPUsersResponse}
      setData(response.data)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      setData(null)
      const id = uuidv4()
      notification.error({
        message: formatMessage({ id: 'notifications.error' }, { correlationId: id }),
        description: formatMessage({ id: 'onboarding.adp.usersStep.failed' }),
        duration: 100,
      })
      logger.error(id, error)
    }
  }

  return (
    <div className='main-content addons-view-page'>
      <div className="main-content-header">
        <div className="main-content-header-title">
          <IntlMessages id="automations.ADP" />
        </div>
        <div className="main-content-header-breadcrumb">
          <Breadcrumb
            items={[
              {
                title: <Link to={FrontendUrls.dashboard}><IntlMessages id="sidebar.dashboard" /></Link>,
              },
              {
                title: <Link to={FrontendUrls.addons}><IntlMessages id="sidebar.addons" /></Link>,
              },
              {
                title: <IntlMessages id="automations.ADP" />,
              },
            ]}
          />
        </div>
      </div>
      <div className="main-content-body">
        {loading && (
          <div className='users-step-loading-container'>
            <Spin size='large' className='users-step-spinner' />
            <IntlMessages id="onboarding.adp.usersStep.loading" />
          </div>
        )}
        {!loading && data && (
          <div className='adp-addon-view' style={{ maxWidth: 800, margin: '0 auto' }}>
            <Card className='users-step-card' variant='outlined'>
              <Row gutter={{ xs: 16, sm: 24, md: 32, lg: 48, xl: 72 }} justify='space-between' align='middle'>
                {data.seats > 0 && <Col xs={24} sm={12} md={8} lg={8} xl={8} className='users-step-col'>
                  <Title level={2} className='users-step-number'>{data.seats}</Title>
                  <Text className='users-step-label'><IntlMessages id="billing.seats" /></Text>
                </Col>}
                <Col xs={24} sm={12} md={8} lg={8} xl={8} className='users-step-col'>
                  <Title level={2} className='users-step-number'>
                    {data?.adp?.total}{data?.adp?.total === 1500 ? '+' : ''}
                  </Title>
                  <Text className='users-step-label'><IntlMessages id="onboarding.adp.usersStep.info5" /></Text>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={8} className='users-step-col'>
                  <Title level={2} className='users-step-number'>{data?.adp?.integrated}</Title>
                  <Text className='users-step-label'><IntlMessages id="app.integrated" /></Text>
                </Col>
              </Row>
            </Card>
            <Paragraph className='users-step-info' style={{ marginTop: 16 }}>
              <IntlMessages id="onboarding.adp.emailMatchInfo" />
            </Paragraph>
            <Row gutter={{ xs: 12, sm: 16, md: 24 }} justify='start' align='middle' style={{ marginTop: 8 }}>
              {data.seats > 0 && <Col>
                <Text><IntlMessages id='addons.adp.needMoreSeats' /> </Text>
                <ADPMarketplaceBtn />
              </Col>}
              <Col>
                <Text><IntlMessages id='addons.adp.needMoreUsers' /> </Text>
                <Link to={authCompany?.platform === PlatformEnum.Email ? '/app/users/import-email-users' : '/app/users/import'}>
                  <Button type='link' size='large'>
                    <IntlMessages id={'users.importUsers'} />
                  </Button>
                </Link>
              </Col>
              <Col>
                <Text><IntlMessages id='addons.adp.visitMarketplace' /> </Text>
                <ADPMarketplaceBtn />
              </Col>
            </Row>
          </div>
        )}
      </div>
    </div>
  )
}

export default AdpAddonView

